import Api from 'api';

import {
  GET_HISTORICS_REPORT_CSV,
  GET_HISTORICS_REPORT_XLSX,
  GET_HISTORICS_REPORT_PDF,
  GET_HISTORICS_REPORT_PAGINATED,
  SET_HISTORICS_REPORT_PAGINATION,
  SET_HISTORICS_REPORT_FILTERS,
  RESET_HISTORICS_REPORT,
} from 'reports/constants';

export const setHistoricsReportPagination = (payload) => ({
  type: SET_HISTORICS_REPORT_PAGINATION,
  payload,
});

export const setHistoricsReportFilters = (payload) => ({
  type: SET_HISTORICS_REPORT_FILTERS,
  payload,
});

export const getHistoricsReport = (
  companyId,
  subcompanyId,
  filters,
  limit,
  page,
  orderBy,
  order
) => ({
  type: GET_HISTORICS_REPORT_PAGINATED,
  meta: { needAuth: true },
  payload: Api.reports.getHistoricsReportPaginated(
    companyId,
    subcompanyId,
    filters,
    limit,
    page,
    orderBy,
    order
  ),
});

export const getHistoricsReportCSV = (companyId, subcompanyId, filters) => ({
  type: GET_HISTORICS_REPORT_CSV,
  meta: { needAuth: true },
  payload: Api.reports.getHistoricsReportCSV(companyId, subcompanyId, filters),
});

/**
 * @author Jorge Casas
 * 
 * @function getHistoricsReportXLSX
 * 
 * @description This function is used to get the historics report in XLSX format
 * 
 * @param {number} companyId
 * @param {number} subcompanyId
 * @param {object} filters
 * @returns {object}
 * 
 * @version 3.4.7
 */
export const getHistoricsReportXLSX = (companyId, subcompanyId, filters) => ({
  type: GET_HISTORICS_REPORT_XLSX,
  meta: { needAuth: true },
  payload: Api.reports.getHistoricsReportXLSX(companyId, subcompanyId, filters),
});

export const getHistoricsReportPDF = (companyId, subcompanyId, filters) => ({
  type: GET_HISTORICS_REPORT_CSV,
  meta: { needAuth: true },
  payload: Api.reports.getHistoricsReportArray(companyId, subcompanyId, filters),
});

export const resetHistoricsReport = () => ({
  type: RESET_HISTORICS_REPORT,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/actions/historics_report_actions.js